import { render, staticRenderFns } from "./doctorCourseDetails.vue?vue&type=template&id=39b02761&scoped=true"
import script from "./doctorCourseDetails.vue?vue&type=script&lang=js"
export * from "./doctorCourseDetails.vue?vue&type=script&lang=js"
import style0 from "./doctorCourseDetails.vue?vue&type=style&index=0&id=39b02761&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b02761",
  null
  
)

export default component.exports